module.exports = __webpack_public_path__ + "static/media/18ECA6.52bf83cf.jpg";